export const formatDate = (date: any): string => {
	if (!date || isNaN(new Date(date).getTime())) {
		return "";
	}
	if (date === "2000-01-01T00:00:00" || date === "2000-01-01") {
		return "";
	}
	return new Date(date).toISOString().split("T")[0];
};

export const formatDateHora = (date: Date): string => {
	const isoString = date.toISOString();
	if (
		isoString === "2000-01-01T00:00:00.000Z" ||
		isoString.startsWith("2000-01-01")
	) {
		return "";
	}
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	return `${year}-${month}-${day}T${hours}:${minutes}`;
};
